import _ from "lodash";
import React from "react";
import I18nHOC from "UIComponents/I18nHOC";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import { getCurrentProjectGroupDetails } from "Projects/modules/ProjectModules";
import {
  TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
  TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_ATLS_MYP,
  TEMPLATE_FIELD_OBJECTIVES_MYP,
  TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_PROCESS_STAGES,
  TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
  TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
} from "Constants/stringConstants";
import LevelsWrapper from "./components/LevelsWrapper";
import CheckListWrapper from "./components/CheckListWrapper";
import { TAGGABLE_PROJECT_ELEMENTS } from "ProcessJournal/modules/Module";
import update from "immutability-helper";
import { DSProvider } from "@toddle-edu/ds-web";

const TagProjectElement = props => {
  const {
    screenPanelProps,
    plannerElementSets,
    projectGroupType,
    organizationId,
    isDsComponent = false,
  } = props;
  const {
    currentElementTag,
    postDetails,
    updatePost,
    onCloseClick,
  } = screenPanelProps;

  const elementObj = _.find(TAGGABLE_PROJECT_ELEMENTS, {
    value: currentElementTag,
  });
  const elementPYP = _.get(postDetails, "elementPYP", []);
  const fieldData = _.find(elementPYP, {
    fieldUID: currentElementTag,
  });
  const onSubmitClick = ({ nodes: allNodes, selections, shouldCloseModal }) => {
    const fieldUIDIndex = _.findIndex(elementPYP, {
      fieldUID: currentElementTag,
    });

    let updatedFieldData = update(
      fieldData || { fieldUID: currentElementTag, parentType: "PROJECT" },
      {
        value: value => update(value || [], { $set: selections }),
      }
    );

    updatedFieldData = update(updatedFieldData, {
      resolvedMinimalTree: resolvedMinimalTree =>
        update(resolvedMinimalTree || {}, {
          nodes: nodes => update(nodes || [], { $set: allNodes }),
        }),
    });

    if (fieldUIDIndex < 0) {
      updatePost({
        elementPYP: update(elementPYP || [], {
          $push: [updatedFieldData],
        }),
      });
    } else {
      updatePost({
        elementPYP: update(elementPYP, {
          $splice: [[fieldUIDIndex, 1, updatedFieldData]],
        }),
      });
    }
    if (shouldCloseModal) {
      onCloseClick();
    }
  };

  const newProps = {
    screenPanelProps,
    plannerElementSets,
    projectGroupType,
    fieldData,
    elementObj,
    onSubmitClick,
    organizationId,
    isDsComponent,
    dsVersion: "2.0",
  };

  switch (currentElementTag) {
    case TEMPLATE_FIELD_ATLS_MYP:
    case TEMPLATE_FIELD_OBJECTIVES_MYP:
      return (
        <DSProvider dsVersion="2.0">
          <LevelsWrapper {...newProps} />
        </DSProvider>
      );
    case TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP:
    case TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP:
    case TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP:
    case TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP:
    case TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES:
    case TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS:
    case TEMPLATE_FIELD_CE_PROCESS_STAGES:
      return <CheckListWrapper {...newProps} />;
    default:
      return null;
  }
};

const mapStateToProps = state => {
  const organizationId = state.login.userInfo.org_id;
  const { type: projectGroupType } = getCurrentProjectGroupDetails({
    state,
  });

  return {
    projectGroupType,
    organizationId,
    plannerElementSets: state.platform.currentPlannerElementSets,
  };
};

export default compose(
  connect(mapStateToProps, null),
  I18nHOC({ resource: ["common"] })
)(TagProjectElement);
